export const API_LOGIN = "/v1/login"
